import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/src/stylus/app.styl'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'

Vue.component('font-awesome-icon', FontAwesomeIcon) // Register component globally
library.add(fas) // Include needed icons.

Vue.use(Vuetify, {
  iconfont: 'faSvg',
  theme: {
    primary: '#1072BA',
    accent: '#57BE8E'
  },
  icons: {
    custom: {
      component: FontAwesomeIcon,
      props: {
        icon: ['fas', 'redo']
      }
    }
  }
})
